'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';


interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const pathname = usePathname();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems: {label: string;href: string;icon: string;}[] = [];

  const moreMenuItems: {label: string;href: string;icon: string;}[] = [];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActiveRoute = (href: string) => {
    return pathname === href;
  };

  return (
    <>
      <header data-component-id="src/components/common/Header.tsx:46:6" data-component-path="src/components/common/Header.tsx" data-component-line="46" data-component-end-line="147" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/80 backdrop-blur-md shadow-card' : 'bg-transparent'} ${
        className}`}>

        <div data-component-id="src/components/common/Header.tsx:51:8" data-component-path="src/components/common/Header.tsx" data-component-line="51" data-component-end-line="146" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%22%7D" className="w-full">
          {/* Logo at top center - 3x bigger with WhatsApp button */}
          <div data-component-id="src/components/common/Header.tsx:53:10" data-component-path="src/components/common/Header.tsx" data-component-line="53" data-component-end-line="79" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20py-2%20relative%22%7D" className="flex justify-center items-center py-2 relative">
            <Link data-component-id="src/components/common/Header.tsx:54:12" data-component-path="src/components/common/Header.tsx" data-component-line="54" data-component-end-line="60" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fhomepage%22%2C%22className%22%3A%22flex%20items-center%22%7D" href="/homepage" className="flex items-center">
              <AppImage data-component-id="src/components/common/Header.tsx:55:14" data-component-path="src/components/common/Header.tsx" data-component-line="55" data-component-end-line="59" data-component-file="Header.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22src%22%3A%22%2Fassets%2Fimages%2FAA_BG_RE-1766867640602.png%22%2C%22alt%22%3A%22AELY%20AI%20-%20Automate%20Your%20Business%22%2C%22className%22%3A%22h-48%20w-auto%20object-contain%22%7D"
                src="/assets/images/AA_BG_RE-1766867640602.png"
                alt="AELY AI - Automate Your Business"
                className="h-48 w-auto object-contain"
              />
            </Link>
            
            {/* WhatsApp Now Button - positioned on the right */}
            <a data-component-id="src/components/common/Header.tsx:63:12" data-component-path="src/components/common/Header.tsx" data-component-line="63" data-component-end-line="78" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22https%3A%2F%2Fwa.me%2F1234567890%22%2C%22className%22%3A%22absolute%20right-4%20md%3Aright-8%20flex%20items-center%20gap-2%20px-6%20py-3%20bg-%5B%2325D366%5D%20hover%3Abg-%5B%2320BA5A%5D%20text-white%20font-semibold%20rounded-full%20transition-all%20duration-300%20shadow-lg%20hover%3Ashadow-xl%20transform%20hover%3Ascale-105%22%7D"
              href="https://wa.me/1234567890"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute right-4 md:right-8 flex items-center gap-2 px-6 py-3 bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <svg data-component-id="src/components/common/Header.tsx:69:14" data-component-path="src/components/common/Header.tsx" data-component-line="69" data-component-end-line="76" data-component-file="Header.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-5%20h-5%22%7D"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path data-component-id="src/components/common/Header.tsx:75:16" data-component-path="src/components/common/Header.tsx" data-component-line="75" data-component-end-line="75" data-component-file="Header.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              <span data-component-id="src/components/common/Header.tsx:77:14" data-component-path="src/components/common/Header.tsx" data-component-line="77" data-component-end-line="77" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22hidden%20sm%3Ainline%22%2C%22textContent%22%3A%22WhatsApp%20Now%22%7D" className="hidden sm:inline">WhatsApp Now</span>
            </a>
          </div>

          {/* Navigation - keeping existing structure */}
          






          
























































        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div data-component-id="src/components/common/Header.tsx:151:6" data-component-path="src/components/common/Header.tsx" data-component-line="151" data-component-end-line="182" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-40%20lg%3Ahidden%22%7D" className="fixed inset-0 z-40 lg:hidden">
          <div data-component-id="src/components/common/Header.tsx:152:10" data-component-path="src/components/common/Header.tsx" data-component-line="152" data-component-end-line="181" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20bg-background%22%7D" className="fixed inset-0 bg-background" style={{ top: '64px' }}>
            <nav data-component-id="src/components/common/Header.tsx:153:12" data-component-path="src/components/common/Header.tsx" data-component-line="153" data-component-end-line="180" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22flex%20flex-col%20h-full%20overflow-y-auto%22%7D" className="flex flex-col h-full overflow-y-auto">
              <div data-component-id="src/components/common/Header.tsx:154:14" data-component-path="src/components/common/Header.tsx" data-component-line="154" data-component-end-line="170" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20px-4%20py-6%20space-y-2%22%7D" className="flex-1 px-4 py-6 space-y-2">
                {navigationItems.map((item) =>
              <Link data-component-id="src/components/common/Header.tsx:156:14" data-component-path="src/components/common/Header.tsx" data-component-line="156" data-component-end-line="168" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                key={item.href}
                href={item.href}
                onClick={closeMobileMenu}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg font-medium transition-all duration-300 ${
                isActiveRoute(item.href) ?
                'bg-primary text-primary-foreground shadow-interactive' :
                'text-text-primary hover:bg-muted'}`
                }>

                    <Icon data-component-id="src/components/common/Header.tsx:166:20" data-component-path="src/components/common/Header.tsx" data-component-line="166" data-component-end-line="166" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={item.icon as any} size={24} />
                    <span data-component-id="src/components/common/Header.tsx:167:20" data-component-path="src/components/common/Header.tsx" data-component-line="167" data-component-end-line="167" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{item.label}</span>
                  </Link>
              )}
              </div>

              <div data-component-id="src/components/common/Header.tsx:172:14" data-component-path="src/components/common/Header.tsx" data-component-line="172" data-component-end-line="179" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22px-4%20py-6%20space-y-3%20border-t%20border-border%20bg-card%22%7D" className="px-4 py-6 space-y-3 border-t border-border bg-card">
                <button data-component-id="src/components/common/Header.tsx:173:16" data-component-path="src/components/common/Header.tsx" data-component-line="173" data-component-end-line="175" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20px-4%20py-3%20text-primary%20font-semibold%20rounded-lg%20border-2%20border-primary%20hover%3Abg-primary%20hover%3Atext-primary-foreground%20transition-all%20duration-300%22%2C%22textContent%22%3A%22Try%20Demo%22%7D" className="w-full px-4 py-3 text-primary font-semibold rounded-lg border-2 border-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                  Try Demo
                </button>
                <button data-component-id="src/components/common/Header.tsx:176:16" data-component-path="src/components/common/Header.tsx" data-component-line="176" data-component-end-line="178" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20px-4%20py-3%20bg-brand-conversion%20text-white%20font-semibold%20rounded-lg%20hover%3Abg-opacity-90%20transition-all%20duration-300%20shadow-interactive%22%2C%22textContent%22%3A%22Get%20Started%22%7D" className="w-full px-4 py-3 bg-brand-conversion text-white font-semibold rounded-lg hover:bg-opacity-90 transition-all duration-300 shadow-interactive">
                  Get Started
                </button>
              </div>
            </nav>
          </div>
        </div>
      }
    </>);

};

export default Header;